import type { ProductionRecordSearchParams, WellVersions } from './types';

/** useProduction's extra params asking daily production for each month's total. */
export const MONTHLY_GRANULARITY: Partial<ProductionRecordSearchParams> = {
  responseConfig: { granularity: 'monthly' },
};

/** useProduction's extra params asking daily production for one row per day. */
export const DAILY_GRANULARITY: Partial<ProductionRecordSearchParams> = {
  responseConfig: { granularity: 'daily' },
};

/**
 * useProduction's extra params asking daily production for one row per day,
 * with each row's running totals, ratios and material balance time. For charts
 * that plot those, or use them as the x-axis.
 */
export const DAILY_GRANULARITY_WITH_SERIES: Partial<ProductionRecordSearchParams> =
  {
    responseConfig: {
      granularity: 'daily',
      includeCumulativeProduction: true,
      includeRatiosProduction: true,
      includeMbtProduction: true,
    },
  };

/** No versions, which keeps useProduction from fetching. */
export const NO_VERSIONS: WellVersions = [];
